/* eslint-disable max-len */
const company = {
  COUNTRY: 'Россия',
  NAME: 'MyGig',
  LOGO: 'https://app.mygig.ru/img/logo.svg',
  SITE: 'https://mygig.ru',
  EMAIL: 'help@mygig.ru',
  PHONE: '+7 (495) 215-53-58',
  DESCRIPTION: 'MyGig - ваш новый способ подработки. Выбирайте прямо на карте удобное время, специальность и график. Оплата сразу после смены.',
};

module.exports = company;
